import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import styles from "../Home.module.css";
export default function HomeHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="hero" className={`relative bg-background overflow-hidden py-16 lg:py-24 min-h-[560px] lg:min-h-[640px] flex items-center ${styles.homeGridBackground}`}>
      {/* Full-bleed background photo */}
      <div className="absolute inset-0 z-0 pointer-events-none select-none">
        <img src="https://edustrategygroup.com/wp-content/uploads/2026/10/academic_university_campus_quad-1.png" alt="University campus quad with red-brick buildings, a white cupola and students walking along the paths" className="w-full h-full object-cover object-[70%_center] lg:object-[80%_center]" loading="eager" />
        {/* Fade overlay blending photo into var(--background) */}
        <div className={styles.heroPhotoFade} aria-hidden="true" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl lg:max-w-3xl">
          {/* Left Column */}
          <div ref={ref} className={`flex flex-col items-start transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {/* Accent dashes (blue + navy) */}
            <div className="flex items-center gap-2 mb-6" aria-hidden="true">
              <span className="w-8 h-1 rounded-full bg-accent" />
              <span className="w-8 h-1 rounded-full bg-primary" />
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight text-foreground leading-[1.08] mb-6">
              Growth you own. Capacity you{" "}
              <span className="text-accent">keep</span>.
            </h1>

            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-2xl mb-10">
              EduStrategy Group is the strategic growth partner for mission-driven
              colleges and universities. We co-design lifelong learning ecosystems
              that build internal capability — not external dependency.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <Button asChild size="lg" className="rounded-full bg-accent hover:bg-accent/90 text-accent-foreground font-semibold px-7 h-12 shadow-sm transition-all">
                <Link to="/ProfessionalServicesPage">
                  Explore Professional Services <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full bg-background hover:bg-muted text-foreground border-border font-semibold px-7 h-12 transition-all">
                <Link to="/TechnologyPage">
                  See what&apos;s coming <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}